import { Children, isValidElement, useRef } from 'react'

import { useSlideAside } from './useSlideAside'

import type { FC } from 'react'

type SlideAsideProps = {
  className?: string
  children?: React.ReactNode
}

export const SlideAside: FC<SlideAsideProps> = ({ className, children }) => {
  const ref = useRef<HTMLDivElement>(null)
  useSlideAside(ref)

  return (
    <div ref={ref} className={className} style={{ minHeight: '400px' }}>
      <div className="sticky left-0 block w-full top-[calc(32px_+_var(--header-height))] max-xl:top-[calc(32px_+_var(--header-height))]">
        {Children.map(children, (child) => {
          if (!isValidElement(child)) return null

          return (
            <div
              className="absolute top-0 left-0 opacity-0 w-full invisible [&.static]:static [transition:duration_.35s_ease,visibility_.35s_0s] [&.show]:visible [&.show]:opacity-100 [&.show]:[transition:opacity_.35s_ease,visibility_0s]"
              style={{
                willChange: 'opacity,visibility',
              }}
            >
              {child}
            </div>
          )
        })}
      </div>
    </div>
  )
}
